export default __webpack_public_path__ + "static/media/LogoQR.8975e88b.svg";